import { ResourceOptions } from 'react-admin';
import { MdSyncAlt } from 'react-icons/md';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.xbitRelayTransfers;
export {
  XBIT_RELAY_TRANSFERS_PERMISSION_RESOURCE,
  XBIT_RELAY_TRANSFERS_READ_ACTION,
  XBIT_RELAY_TRANSFERS_APPROVE_ACTION,
} from './constants';
export const icon = MdSyncAlt;
export const options: ResourceOptions = {
  label: 'module.xbitRelayTransfers.title',
};
